/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GraphDefs from './defs.defs.js'

const $nsid = 'app.bsky.graph.getListsWithMembership'

export { $nsid }

/** Enumerates the lists created by the session user, and includes membership information about `actor` in those lists. Only supports curation and moderation lists (no reference lists, used in starter packs). Requires auth. */
const main = l.query(
  $nsid,
  l.params({
    actor: l.string({ format: 'at-identifier' }),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
    purposes: l.optional(
      l.array(l.string<{ knownValues: ['modlist', 'curatelist'] }>()),
    ),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    listsWithMembership: l.array(
      l.ref<ListWithMembership>((() => listWithMembership) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

/** A list and an optional list item indicating membership of a target user to that list. */
type ListWithMembership = {
  $type?: 'app.bsky.graph.getListsWithMembership#listWithMembership'
  list: GraphDefs.ListView
  listItem?: GraphDefs.ListItemView
}

export type { ListWithMembership }

/** A list and an optional list item indicating membership of a target user to that list. */
const listWithMembership = l.typedObject<ListWithMembership>(
  $nsid,
  'listWithMembership',
  l.object({
    list: l.ref<GraphDefs.ListView>((() => GraphDefs.listView) as any),
    listItem: l.optional(
      l.ref<GraphDefs.ListItemView>((() => GraphDefs.listItemView) as any),
    ),
  }),
)

export { listWithMembership }
